export default __webpack_public_path__ + "static/media/KozlekedesiAnomaliak.b3e95919.jpg";